import { UserService } from './../../shared/user.service';
import { FirestoreService } from 'common-lib';
import { AngularFireAuth } from '@angular/fire/auth';
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl } from '@angular/forms';
import { auth } from 'firebase';

declare let tracker: any; // KARTEタグ

@Component({
  selector: 'app-signin-page',
  templateUrl: './signin-page.component.html',
  styleUrls: ['./signin-page.component.scss'],
})
export class SigninPageComponent implements OnInit {
  backUrl: string;
  errorMessage = '';
  signinForm = new FormGroup({
    email: new FormControl(),
    password: new FormControl(),
  });
  previousUrl: string;

  constructor(
    private router: Router,
    private auth: AngularFireAuth,
    private users: UserService,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    const url = this.route.snapshot.queryParamMap.get('url');
    console.log('test' + url);
    this.backUrl = url ? url : '';
  }

  async doSignin() {
    const data = this.signinForm.value;
    try {
      const user = await this.auth.auth.signInWithEmailAndPassword(data['email'], data['password']);
      console.log(user);
      this.navigateNext();
    } catch (e) {
      this.errorMessage = 'ログインに失敗しました';
      console.log(e);
    }
  }

  async signinWithFacebook() {
    try {
      const user = await this.auth.auth.signInWithRedirect(new auth.FacebookAuthProvider());
      console.log(user);
      this.navigateNext();
    } catch (e) {
      this.errorMessage = 'ログインに失敗しました';
      console.log(e);
    }
  }

  async signinWithGoogle() {
    try {
      const user = await this.auth.auth.signInWithPopup(new auth.GoogleAuthProvider());
      console.log(user);
      this.navigateNext();
    } catch (e) {
      this.errorMessage = 'ログインに失敗しました';
      console.log(e);
    }
  }

  private async navigateNext() {
    // KARTEタグ: ログイン
    tracker.track('login', {
      status: true,
    });

    console.log(this.backUrl);
    if (this.backUrl && this.backUrl.length > 0) {
      try {
        await this.router.navigateByUrl(this.backUrl);
        return;
      } catch (e) {}
    }
    const profile = await this.users.getProfile();
    if (profile && (await this.users.isValidProfile())) {
      this.router.navigate(['/']);
    } else {
      this.router.navigate(['/profile']);
    }
  }

  private showError(e) {
    let errorMessage = 'ログインに失敗しました';

    if (e.code) {
      switch (e.code) {
        case 'auth/credential-already-in-use':
          errorMessage = 'メールアドレスが既に登録されています';
          break;
        default:
          break;
      }
    }

    this.errorMessage = errorMessage;
  }
}
